var angular = require('angular')
angular.module('promemoria').component('auiRelated', {
  bindings: {
    item: '@',
    table: '@',
    baseUrl: '@'
  },
  template: require('./related.html'),
  controller: function ($scope, $element, $attrs, $http, ENDPOINT_RELATED, LINKS) {
    var ctrl = this
    ctrl._ = _
    ctrl.LINKS = LINKS
    ctrl.$onInit = function () {
      $http
        .post(ENDPOINT_RELATED + '/' + ctrl.table + '/' + ctrl.item)
        .then(function (result) {
          var relatedMapKey = {
            'ca_objects': 'ARisorse collegate',
            'ca_entities': 'BSoggetti',
            'ca_places': 'ELuoghi',
            'ca_occurrences': 'CAltri riferimenti',
            'ca_collections': 'CCollezioni'
          }

          var data = _.map(result.data.data, function (elem) {
            elem.interstitial = _createIntestitialString(elem.interstitial)
            if (elem.rel_id === parseInt(ctrl.item, 10)) {
              elem.rel_id = elem.id
              elem.rel_label = elem.label
              elem.rel_table = elem.table
            }

            elem.groupby = relatedMapKey[elem.rel_table]
            return elem
          })

          // da rimuovere
          data = _.uniqBy(data, 'rel_id')

          var related = _.groupBy(data, 'groupby')

          if (_.isEmpty(related)) {
            return false
          }

          ctrl.related = _.mapKeys(_(related).toPairs().sortBy(0).fromPairs().value(), function (value, key) {
            return key.substring(1)
          })
        })
    }

    ctrl.popover = function () {
      jQuery('[data-toggle="popover"]').popover({
        html: true
      })
    }
  }
})

function _createIntestitialString (elem) {
  var string = ''

  _.forEach(elem, function (interstitial) {
    string += '<b>' + interstitial['name'] + '</b>: ' + interstitial['value'] + '</br>'
  })

  return string
}



// WEBPACK FOOTER //
// ./src/js/components/related/related.js